/**
 * Web configuration identifies the Firebase project; it is not a secret (ADR-006), but it is
 * still supplied through untracked `.env.local`. Returns null when not configured, in which
 * case only the DEMO personas are offered and the Firebase SDK is never downloaded.
 */
export function readFirebaseConfig() {
  const env = import.meta.env;
  const apiKey = env.VITE_FIREBASE_API_KEY as string | undefined;
  const authDomain = env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined;
  const projectId = env.VITE_FIREBASE_PROJECT_ID as string | undefined;
  const appId = env.VITE_FIREBASE_APP_ID as string | undefined;
  if (!apiKey || !authDomain || !projectId) return null;
  return {
    options: { apiKey, authDomain, projectId, ...(appId ? { appId } : {}) },
    emulatorUrl: env.VITE_FIREBASE_AUTH_EMULATOR_URL as string | undefined,
  };
}

export type FirebaseConfig = NonNullable<ReturnType<typeof readFirebaseConfig>>;
